// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6 2V3H18V2H20V3H21V5H20.2198L20.8198 8H22V10H21V20H22V22H2V20H3V10H2V8H3.1802L3.7802 5H3V3H4V2H6ZM19 10H16V20H19V10ZM14 20V10H10V20H14ZM8 20V10H5V20H8Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-archway-filled')
export default class ArchwayFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'archway-filled',
    }
  }
}
